export const RecordLockedContract = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'http://example.com/product.schema.json',
    $title: 'Record is Locked Modal',
    $description: 'JSON Schema Contract for Record is Locked Modal',
    $type: 'object',
    properties: {
    }
};
